import { useCookieConsentStore } from '@onbeam/utils';
import { Modal } from '@sphere/ui';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';
import { CookieConsentModal } from './CookieConsentModal';
import { CookieConsentPopup } from './CookieConsentPopup';

export const CookieConsent = () => {
  const { t } = useTranslation('common');
  const { isConsentModalOpen: isOpen, closeConsentModal: onClose } = useCookieConsentStore();

  return (
    <>
      <Modal
        testId="consent-modal"
        isOpen={isOpen}
        title={t('cookie-modal.modal-title')}
        maxW={rem(512)}
        onClose={onClose}
      >
        <CookieConsentModal />
      </Modal>
      <CookieConsentPopup />
    </>
  );
};
